<template>
    <div style="height: 100%">
        <!--     <b-tabs vertical id="tabsRsaPazienteAreeView" ref="tabsRsaPazienteAreeView" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items sa-tab-items-aree sa-tab-items-vertical" content-class="mt-3" class="sa-tab" style="padding-bottom: 25px" fill @input="onInputTabs"> -->
        <sa-tabs-scroll-component idTab="tabsRsaAree" classNavItem="nav-item"></sa-tabs-scroll-component>
        <b-tabs id="tabsRsaAree" ref="tabsRsaAree" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
            <!-- </b-tabs> -->
            <b-tab v-for="areaTab in areeTabs" :key="areaTab.id" :title="areaTab.nome">
                <div class="sa-accordion-wrapper">
                    <form>
                        <div class="sa-accordion">
                            <input class="sa-accordion-input" type="radio" :name="areaTab.id + 'radio-a'" :id="areaTab.id + 'radio-a'" value="1" checked="checked" />

                            <label class="sa-accordion-label" :for="areaTab.id + 'radio-a'">
                                PIANIFICAZIONE

                                <b-button size="sm" v-if="areaTab.nome != 'SOMMINISTRAZIONE TERAPEUTICA'" variant="outline-success outline-secondary-noborder pull-right sa-accordion-btn" @click="onClickNuovaPianificazione()">
                                    <i class="fas fa-plus"></i>
                                    Aggiungi
                                </b-button>
                                <b-button v-if="areaTab.nome == 'SOMMINISTRAZIONE TERAPEUTICA'" size="sm" variant="outline-purple outline-secondary-noborder pull-right sa-accordion-btn" @click="onClickStampa()">
                                    <b-icon icon="printer" />
                                    Stampa
                                </b-button>

                                <b-button v-if="areaTab.nome == 'SOMMINISTRAZIONE TERAPEUTICA'" variant="outline-info outline-secondary-noborder pull-right sa-accordion-btn" size="sm" @click="onScaricaCsv">
                                    <font-awesome-icon icon="file-csv" />
                                    Download Csv
                                </b-button>

                                <b-form-checkbox class="pull-right sa-accordion-btn" v-model="mostraTutte" size="lg" switch>
                                    <span style="font-size: 1rem; vertical-align: middle; height: 100%; display: inline-block; margin-top: -3px; margin-right: 10px">Mostra tutte</span>
                                </b-form-checkbox>
                                <b-form-checkbox v-if="areaTab.nome == 'SOMMINISTRAZIONE TERAPEUTICA'" class="pull-right sa-accordion-btn" v-model="raggruppa" size="lg" switch>
                                    <span style="font-size: 1rem; vertical-align: middle; height: 100%; display: inline-block; margin-top: -3px; margin-right: 10px"> Raggruppa</span>
                                </b-form-checkbox>
                            </label>
                            <div class="sa-accordion-content">
                                <div class="b-table-sticky-header">
                                    <template v-if="raggruppa && areaTab.nome == 'SOMMINISTRAZIONE TERAPEUTICA'">
                                        <template v-if="pianificazioni.length > 0">
                                            <div v-for="(listaFarmaci, nomeGruppo, indexGruppo) in getFarmaciRaggruppati" :key="nomeGruppo">
                                                <div class="sa-utility-section mb-3 d-flex justify-content-between align-items-center" v-b-toggle="'collapse-gruppo-' + indexGruppo" style="cursor: pointer">
                                                    <div>
                                                        <i class="fas fa-capsules" style="color: var(--bg-sidebar); font-size: 16px"></i>
                                                        <span class="sa-articolo-section-title ml-2">{{ nomeGruppo }}</span>
                                                    </div>

                                                    <i class="fas fa-chevron-up sa-ft-icona-collapse"></i>
                                                </div>

                                                <b-collapse :id="'collapse-gruppo-' + indexGruppo" visible>
                                                    <div class="sa-card-list">
                                                        <div v-for="(item, index) in listaFarmaci" :key="item.primaryKey || index" class="sa-ft-modern-card" :style="{ '--hover-color': getClass('hover', item.tipologia) }" :class="getClass('card', item.tipologia)">
                                                            <b-row align-v="center" class="m-0 py-3">
                                                                <b-col cols="12" md="5" class="mb-2 mb-md-0">
                                                                    <div class="sa-ft-label-pai">{{ item.nomeAttivita }}</div>
                                                                    <div class="sa-ft-valore-pai primary-text">
                                                                        <span v-html="getTestoHtmlNomeAttivita(item, 'PRESCRIZIONE')"></span>
                                                                    </div>
                                                                </b-col>
                                                                <b-col cols="12" md="2" class="mb-2 mb-md-0">
                                                                    <div class="sa-ft-label-pai">INDICAZIONI</div>
                                                                    <div class="sa-ft-valore-pai text-muted small text-break" style="max-height: 60px; overflow-y: auto">
                                                                        <div v-html="item.indicazioni"></div>
                                                                    </div>
                                                                </b-col>
                                                                <b-col cols="12" md="2" class="mb-2 mb-md-0">
                                                                    <div class="sa-ft-label-pai">PROGRAMMAZIONE</div>
                                                                    <div class="sa-ft-valore-pai text-muted small">
                                                                        {{ item.programmazione }}
                                                                    </div>
                                                                </b-col>

                                                                <b-col cols="6" md="2" class="mb-2 mb-md-0 text-center align-content-center">
                                                                    <div class="sa-ft-label-pai">STATO</div>
                                                                    <div class="mt-1">
                                                                        <span class="sa-ft-badge" :class="getClass('stato', item.tipologia)">
                                                                            {{ item.tipologia }}
                                                                        </span>
                                                                    </div>
                                                                </b-col>

                                                                <b-col cols="6" md="1" class="mb-2 mb-md-0 align-content-center">
                                                                    <div class="sa-ft-label-pai">INIZIO / FINE</div>
                                                                    <div class="sa-ft-valore-pai small">
                                                                        <div>Inizio: {{ formatDate(item.dataInizio) }}</div>
                                                                        <div v-if="item.dataFine">Fine: {{ formatDate(item.dataFine) }}</div>
                                                                        <div v-else class="text-muted">Fine: --</div>
                                                                    </div>
                                                                </b-col>
                                                            </b-row>
                                                        </div>
                                                    </div>
                                                </b-collapse>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <NoDataComponent ref="cmpNoDataComponent" title="Non sono presenti prescrizioni" nome="no-data" subtitle="" icon="fas fa-capsules" />
                                        </template>
                                    </template>
                                    <template v-else-if="raggruppa && areaTab.nome == 'RIABILITAZIONE MOTORIA'">
                                        <template v-if="pianificazioni.length > 0">
                                            <div v-for="(liestaEsercizi, nomeGruppo, indexGruppo) in getEserciziRaggruppati" :key="nomeGruppo">
                                                <div class="sa-utility-section mb-3 d-flex justify-content-between align-items-center" v-b-toggle="'collapse-gruppo-' + indexGruppo" style="cursor: pointer">
                                                    <div>
                                                        <i class="fas fa-capsules" style="color: var(--bg-sidebar); font-size: 16px"></i>
                                                        <span class="sa-articolo-section-title ml-2">{{ nomeGruppo }}</span>
                                                    </div>

                                                    <i class="fas fa-chevron-up sa-ft-icona-collapse"></i>
                                                </div>

                                                <b-collapse :id="'collapse-gruppo-' + indexGruppo" visible>
                                                    <div class="sa-card-list">
                                                        <div v-for="(item, index) in liestaEsercizi" :key="item.primaryKey || index" class="sa-ft-modern-card" :style="{ '--hover-color': getClass('hover', item.tipologia) }" :class="getClass('card', item.tipologia)">
                                                            <b-row align-v="center" class="m-0 py-3">
                                                                <b-col cols="12" md="5" class="mb-2 mb-md-0">
                                                                    <div class="sa-ft-label-pai">{{ item.nomeAttivita }}</div>
                                                                    <div class="sa-ft-valore-pai primary-text">
                                                                        <span v-html="getTestoHtmlNomeAttivita(item, 'PRESCRIZIONE')"></span>
                                                                    </div>
                                                                </b-col>
                                                                <b-col cols="12" md="2" class="mb-2 mb-md-0">
                                                                    <div class="sa-ft-label-pai">INDICAZIONI</div>
                                                                    <div class="sa-ft-valore-pai text-muted small text-break" style="max-height: 60px; overflow-y: auto">
                                                                        <div v-html="item.indicazioni"></div>
                                                                    </div>
                                                                </b-col>
                                                                <b-col cols="12" md="2" class="mb-2 mb-md-0">
                                                                    <div class="sa-ft-label-pai">PROGRAMMAZIONE</div>
                                                                    <div class="sa-ft-valore-pai text-muted small">
                                                                        {{ item.programmazione }}
                                                                    </div>
                                                                </b-col>

                                                                <b-col cols="6" md="2" class="mb-2 mb-md-0 text-center align-content-center">
                                                                    <div class="sa-ft-label-pai">STATO</div>
                                                                    <div class="mt-1">
                                                                        <span class="sa-ft-badge" :class="getClass('stato', item.tipologia)">
                                                                            {{ item.tipologia }}
                                                                        </span>
                                                                    </div>
                                                                </b-col>

                                                                <b-col cols="6" md="1" class="mb-2 mb-md-0 align-content-center">
                                                                    <div class="sa-ft-label-pai">INIZIO / FINE</div>
                                                                    <div class="sa-ft-valore-pai small">
                                                                        <div>Inizio: {{ formatDate(item.dataInizio) }}</div>
                                                                        <div v-if="item.dataFine">Fine: {{ formatDate(item.dataFine) }}</div>
                                                                        <div v-else class="text-muted">Fine: --</div>
                                                                    </div>
                                                                </b-col>
                                                            </b-row>
                                                        </div>
                                                    </div>
                                                </b-collapse>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <NoDataComponent ref="cmpNoDataComponent" title="Non sono presenti prescrizioni" nome="no-data" subtitle="" icon="fas fa-capsules" />
                                        </template>
                                    </template>
                                    <template v-else>
                                        <b-table sticky-header ref="table" stacked="lg" striped hover :items="listpianificazioni" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                                            <!-- <template v-slot:cell(pianificazione)="{ item }">
											{{ item.pianificazione }}
										</template> -->
                                            <template v-slot:cell(nomeAttivita)="{ item }">
                                                <!-- <span>{{ item.nomeAttivita }}</span>
                                            <span class="sa-table-span-label-primary">({{ item.dettaglio }})</span> -->
                                                <span class="sa-table-span-label-primary">{{ item.nomeAttivita }} </span>
                                                <span class="sa-table-span-label-secondary" v-html="item.dettaglio"></span>
                                                <span v-if="areaTab.nome === 'SOMMINISTRAZIONE TERAPEUTICA'" class="sa-table-span-label-secondary"> Via Somministrazione: {{ item.viaSomministrazione }} </span>
                                                <!-- <span v-if="areaTab.nome == 'SOMMINISTRAZIONE TERAPEUTICA'">
												<br />
												<strong v-if="item.params">Dose: {{ getDose(item) }}</strong>
											</span> -->
                                            </template>
                                            <!-- <template v-slot:cell(orari)="{ item }">
											<span v-if="item.orari !== 'null'">
												{{ item.orari }}
											</span>
										</template> -->
                                            <template v-slot:cell(indicazioni)="{ item }">
                                                <span v-html="item.indicazioni"></span>
                                            </template>
                                            <template v-slot:cell(inizioFine)="{ item }">
                                                <span style="display: inline-block; white-space: nowrap">Inizio: {{ formatDate(item.dataInizio) }}</span
                                                ><br />
                                                <span style="display: inline-block; white-space: nowrap">Fine: {{ formatDate(item.dataFine) }}</span>
                                            </template>
                                            <template v-slot:cell(actions)="row">
                                                <b-container class="bv-example-row">
                                                    <b-button v-b-tooltip.hover size="sm" v-if="areaTab.nome != 'SOMMINISTRAZIONE TERAPEUTICA'" variant="outline-primary no-text" title="Modifica Pianificazione" @click="onClickEdit(row.item, row.index, $event.target)" class="mr-1 no-text">
                                                        <b-icon icon="pencil"></b-icon>
                                                    </b-button>
                                                    <b-button v-if="btnPermessiElimina" v-b-tooltip.hover size="sm" variant="outline-danger no-text" title="Elimina Pianificazione" @click="onClickDelete(row.item, row.index, $event.target)" class="mr-1 no-text">
                                                        <b-icon icon="trash"></b-icon>
                                                    </b-button>
                                                </b-container>
                                            </template>
                                        </b-table>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="sa-accordion">
                            <input class="sa-accordion-input" type="radio" :name="areaTab.id + 'radio-a'" :id="areaTab.id + 'radio-b'" value="2" />
                            <label class="sa-accordion-label" :for="areaTab.id + 'radio-b'">
                                ATTIVITA'
                                <b-button size="sm" class="mr-2" variant="outline-success outline-secondary-noborder pull-right sa-accordion-btn" @click="onClickAttivitaExtra()">
                                    <i class="fas fa-plus"></i>
                                    Aggiungi Attivita Extra
                                </b-button>

                                <b-form-checkbox v-if="areaTab.nome == 'SOMMINISTRAZIONE TERAPEUTICA'" class="pull-right sa-accordion-btn" v-model="raggruppaAttivita" size="lg" switch>
                                    <span style="font-size: 1rem; vertical-align: middle; height: 100%; display: inline-block; margin-top: -3px; margin-right: 10px"> Raggruppa Attivita</span>
                                </b-form-checkbox>
                                <!-- <b-button size="sm" variant="outline-success outline-secondary-noborder pull-right sa-accordion-btn" @click="onClickNuovaAttivita()">
                                    <i class="fas fa-plus"></i>
                                    Aggiungi
                                </b-button> -->
                            </label>
                            <div slot="table-filter">
                                <b-form @submit.prevent="onSubmit">
                                    <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                            <label class="sa-label-data">Data Dal</label>
                                            <date-picker v-model="filtroScheduler.dataDal" format="DD-MM-YYYY" value-type="timestamp" type="timestamp"></date-picker>
                                        </b-col>
                                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                            <label class="sa-label-data">Data Al</label>
                                            <date-picker v-model="filtroScheduler.dataAl" format="DD-MM-YYYY" value-type="timestamp" type="timestamp"></date-picker>
                                        </b-col>
                                    </b-row>
                                    <b-row style="margin-top: 5px">
                                        <b-col class="sa-padding-right text-right">
                                            <b-button type="submit" variant="info">Cerca</b-button>
                                            <b-button type="reset" v-on:click="onReset" variant="danger">Reset</b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </div>
                            <div class="sa-accordion-content">
                                <div class="b-table-sticky-header">
                                    <template v-if="raggruppaAttivita && areaTab.nome == 'SOMMINISTRAZIONE TERAPEUTICA'">
                                        <template v-if="attivitaSchedulate.length > 0">
                                            <div v-for="(listaFarmaci, nomeGruppo, indexGruppo) in getAttivitaSomministrazioneFarmacologica" :key="nomeGruppo">
                                                <div class="sa-utility-section mb-3 d-flex justify-content-between align-items-center" v-b-toggle="'collapse-gruppo-' + indexGruppo" style="cursor: pointer">
                                                    <div>
                                                        <i class="fas fa-capsules" style="color: var(--bg-sidebar); font-size: 16px"></i>
                                                        <span class="sa-articolo-section-title ml-2">{{ nomeGruppo }}</span>
                                                    </div>

                                                    <i class="fas fa-chevron-up sa-ft-icona-collapse"></i>
                                                </div>

                                                <b-collapse :id="'collapse-gruppo-' + indexGruppo" visible>
                                                    <div class="sa-card-list">
                                                        <div v-for="(item, index) in listaFarmaci" :key="item.primaryKey || index" class="sa-ft-modern-card" :style="{ '--hover-color': getClass('hover', item.tipologia) }" :class="getClass('card', item.tipologia)">
                                                            <b-row align-v="center" class="m-0 py-3">
                                                                <b-col cols="12" md="4" class="mb-2 mb-md-0">
                                                                    <div class="sa-ft-label-pai">{{ item.nomeAttivita }}</div>
                                                                    <div class="sa-ft-valore-pai primary-text">
                                                                        <span v-html="getTestoHtmlNomeAttivita(item, 'ATTIVITA')"></span>
                                                                    </div>
                                                                </b-col>
                                                                <b-col cols="12" md="2" class="mb-2 mb-md-0">
                                                                    <div class="sa-ft-label-pai">INDICAZIONI</div>
                                                                    <div class="sa-ft-valore-pai text-muted small text-break" style="max-height: 60px; overflow-y: auto">
                                                                        <div v-html="item.indicazioni"></div>
                                                                    </div>
                                                                </b-col>
                                                                <b-col cols="12" md="2" class="mb-2 mb-md-0">
                                                                    <div class="sa-ft-label-pai">NOTE</div>
                                                                    <div class="sa-ft-valore-pai text-muted small">
                                                                        {{ item.note }}
                                                                    </div>
                                                                </b-col>

                                                                <b-col cols="6" md="1" class="mb-2 mb-md-0 text-center align-content-center">
                                                                    <div class="sa-ft-label-pai">STATO</div>
                                                                    <div class="mt-1">
                                                                        <span class="sa-ft-badge" :class="getClass('stato', item.tipologia)">
                                                                            {{ item.tipologia }}
                                                                        </span>
                                                                    </div>
                                                                </b-col>

                                                                <b-col cols="6" md="2" class="mb-2 mb-md-0 align-content-center">
                                                                    <div class="sa-ft-label-pai">Prevista / Effettuata</div>
                                                                    <div class="sa-ft-valore-pai small">
                                                                        <div>Prevista: {{ formatDateTime(item.dataOraPrevista) }}</div>
                                                                        <div v-if="item.dataOraEffettuata">
                                                                            Effettuata:
                                                                            {{ formatDateTime(item.dataOraEffettuata) }}
                                                                        </div>
                                                                        <div v-else class="text-muted">Esecuzione: --</div>
                                                                    </div>
                                                                </b-col>
                                                                <b-col cols="12" md="1" class="text-right mt-3 mt-md-0">
                                                                    <div class="d-flex justify-content-md-end ft-gap-8-px">
                                                                        <template v-if="checkVisible('PROGRAMMATA', item, 'ESEGUI') && getBtnEseguiHidden(item)">
                                                                            <b-button :id="'btnesegui-' + index" v-b-tooltip.hover size="sm" variant="outline-success no-text" title="Esegui Attività" @click="onClickEseguiAttivita(item, index, $event.target)" class="mr-1 no-text rounded-circle sa-ft-floating-btn success"> <b-icon icon="check"></b-icon></b-button>
                                                                        </template>

                                                                        <template v-if="checkVisible('PROGRAMMATA', item, 'ESEGUI_FORM') && getBtnEseguiHidden(item)">
                                                                            <b-button :id="'btneseguiform-' + index" v-b-tooltip.hover size="sm" variant="outline-success no-text" title="Compila Scheda" @click="onClickEseguiAttivitaForm(item, index, $event.target)" class="mr-1 no-text rounded-circle sa-ft-floating-btn success">
                                                                                <i class="fas fa-tasks"></i>
                                                                            </b-button>
                                                                        </template>
                                                                        <template v-if="checkVisible('PROGRAMMATA', item, 'NO_ESEGUI_FORM')">
                                                                            <b-button :id="'btneseguiform-' + index" v-b-tooltip.hover size="sm" variant="outline-danger no-text" title="Non Eseguita" @click="onClickNoEseguiAttivitaForm(item, index, $event.target)" class="mr-1 no-text rounded-circle sa-ft-floating-btn danger">
                                                                                <i class="far fa-times-circle"></i>
                                                                            </b-button>
                                                                        </template>
                                                                        <b-button v-if="checkVisible('INFO', item)" v-b-tooltip.hover size="sm" variant="outline-primary no-text" title="Visualizza Attivita'" @click="onClickInfoAttivita(item, index, $event.target)" class="mr-1 no-text rounded-circle sa-ft-floating-btn primary">
                                                                            <b-icon icon="info"></b-icon>
                                                                        </b-button>
                                                                        <template v-if="checkVisible('INFO', item, 'PRINT')">
                                                                            <!--        <print-component :documentRepository="true" :idRisorsa="row.item.id" :typeButton="'small'"> </print-component> -->
                                                                            <!--  <print-component :data="row" :linkPrintData="linkPrintData(row.item)" typeButton="small"></print-component>-->
                                                                            <!--    <b-button variant="outline-secondary no-text" v-if="row.item.statoFirma !== 'FIRMATA'">
                                                        <b-icon icon="pencil-square"></b-icon>
                                                    </b-button> -->
                                                                            <!-- <b-button v-if="row.item.statoFirma === 'FIRMATA'" size="sm" variant="btn btn-purple waves-effect  waves-light width-sm no-text" style="margin-right: 3px" @click="onPrintPreview(row.item)">
                                                        <b-icon icon="printer"></b-icon>
                                                        <print-component v-if="btnPrintVisible && row.item.statoFirma !== 'FIRMATA'" :jsonData="printData" :linkPrintData="linkPrintData(row.item)" typeButton="small" :firmaGrafometrica="true" :nomeFile="nomeFile" :descrizione="descrizione" :tipoDocumento="tipoDocumento" :codiceApplicativo="codiceApplicativo"></print-component>
                                                    </b-button> -->
                                                                        </template>
                                                                    </div>
                                                                </b-col>
                                                            </b-row>
                                                        </div>
                                                    </div>
                                                </b-collapse>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <NoDataComponent ref="cmpNoDataComponent" title="Non sono presenti attivita prescritte" nome="no-data" subtitle="" icon="fas fa-capsules" />
                                        </template>
                                    </template>
                                    <template v-else-if="raggruppa && areaTab.nome == 'RIABILITAZIONE MOTORIA'">
                                        <template v-if="pianificazioni.length > 0">
                                            <div v-for="(liestaEsercizi, nomeGruppo, indexGruppo) in getEserciziRaggruppati" :key="nomeGruppo">
                                                <div class="sa-utility-section mb-3 d-flex justify-content-between align-items-center" v-b-toggle="'collapse-gruppo-' + indexGruppo" style="cursor: pointer">
                                                    <div>
                                                        <i class="fas fa-capsules" style="color: var(--bg-sidebar); font-size: 16px"></i>
                                                        <span class="sa-articolo-section-title ml-2">{{ nomeGruppo }}</span>
                                                    </div>

                                                    <i class="fas fa-chevron-up sa-ft-icona-collapse"></i>
                                                </div>

                                                <b-collapse :id="'collapse-gruppo-' + indexGruppo" visible>
                                                    <div class="sa-card-list">
                                                        <div v-for="(item, index) in liestaEsercizi" :key="item.primaryKey || index" class="sa-ft-modern-card" :style="{ '--hover-color': getClass('hover', item.tipologia) }" :class="getClass('card', item.tipologia)">
                                                            <b-row align-v="center" class="m-0 py-3">
                                                                <b-col cols="12" md="5" class="mb-2 mb-md-0">
                                                                    <div class="sa-ft-label-pai">{{ item.nomeAttivita }}</div>
                                                                    <div class="sa-ft-valore-pai primary-text">
                                                                        <span v-html="getTestoHtmlNomeAttivita(item, 'PRESCRIZIONE')"></span>
                                                                    </div>
                                                                </b-col>
                                                                <b-col cols="12" md="2" class="mb-2 mb-md-0">
                                                                    <div class="sa-ft-label-pai">INDICAZIONI</div>
                                                                    <div class="sa-ft-valore-pai text-muted small text-break" style="max-height: 60px; overflow-y: auto">
                                                                        <div v-html="item.indicazioni"></div>
                                                                    </div>
                                                                </b-col>
                                                                <b-col cols="12" md="2" class="mb-2 mb-md-0">
                                                                    <div class="sa-ft-label-pai">PROGRAMMAZIONE</div>
                                                                    <div class="sa-ft-valore-pai text-muted small">
                                                                        {{ item.programmazione }}
                                                                    </div>
                                                                </b-col>

                                                                <b-col cols="6" md="2" class="mb-2 mb-md-0 text-center align-content-center">
                                                                    <div class="sa-ft-label-pai">STATO</div>
                                                                    <div class="mt-1">
                                                                        <span class="sa-ft-badge" :class="getClass('stato', item.tipologia)">
                                                                            {{ item.tipologia }}
                                                                        </span>
                                                                    </div>
                                                                </b-col>

                                                                <b-col cols="6" md="1" class="mb-2 mb-md-0 align-content-center">
                                                                    <div class="sa-ft-label-pai">INIZIO / FINE</div>
                                                                    <div class="sa-ft-valore-pai small">
                                                                        <div>Inizio: {{ formatDate(item.dataInizio) }}</div>
                                                                        <div v-if="item.dataFine">Fine: {{ formatDate(item.dataFine) }}</div>
                                                                        <div v-else class="text-muted">Fine: --</div>
                                                                    </div>
                                                                </b-col>
                                                            </b-row>
                                                        </div>
                                                    </div>
                                                </b-collapse>
                                            </div>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <b-table sticky-header ref="table" stacked="lg" :tbody-tr-class="getRowClass" striped hover :items="attivitaSchedulate" :fields="fieldsAttivitaSchedulate" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table" :key="tblAttivitaSchedulateKey" :selectable="isSelectable()" @row-selected="onRowSelectedAttivita">
                                            <template v-slot:cell(nomeAttivita)="{ item }">
                                                <span v-html="getAttivita(item)"></span>
                                                <div v-if="item.annotazione.includes('ATTIVITA EXTRA')">
                                                    <small style="font-weight: bold; margin-left: 1px"> {{ "\n" + "ATTIVITA EXTRA" }}</small>
                                                </div>
                                                <!-- <br />
												<strong>{{ item.dose }}</strong> -->
                                                <!-- <span v-if="areaTab.nome == 'SOMMINISTRAZIONE TERAPEUTICA'" v-html="item.dettaglio"> </span> -->
                                            </template>
                                            <template v-slot:cell(indicazioni)="{ item }">
                                                <span v-html="item.indicazioni"></span>
                                            </template>
                                            <template v-slot:cell(statoFirma)="{ item }">
                                                <b-button v-if="item.statoFirma == 'FIRMATA'" v-b-tooltip.hover.right="onHoverStatoFirma(item)" variant="outline">
                                                    <font-awesome-icon icon="signature" class="text-success" />
                                                </b-button>
                                                <b-button v-else v-b-tooltip.hover.right="onHoverStatoFirma(item)" variant="outline">
                                                    <font-awesome-icon icon="signature" class="text-danger" />
                                                </b-button>
                                            </template>
                                            <template v-slot:cell(actions)="row">
                                                <b-container class="bv-example-row">
                                                    <template v-if="checkVisible('PROGRAMMATA', row.item, 'ESEGUI') && getBtnEseguiHidden(row.item)">
                                                        <b-button :id="'btnesegui-' + row.index" v-b-tooltip.hover size="sm" variant="outline-success no-text" title="Esegui Attività" @click="onClickEseguiAttivita(row.item, row.index, $event.target)" class="mr-1 no-text"> <b-icon icon="check"></b-icon></b-button>
                                                    </template>

                                                    <template v-if="checkVisible('PROGRAMMATA', row.item, 'ESEGUI_FORM') && getBtnEseguiHidden(row.item)">
                                                        <b-button :id="'btneseguiform-' + row.index" v-b-tooltip.hover size="sm" variant="outline-success no-text" title="Compila Scheda" @click="onClickEseguiAttivitaForm(row.item, row.index, $event.target)" class="mr-1 no-text">
                                                            <i class="fas fa-tasks"></i>
                                                        </b-button>
                                                    </template>
                                                    <template v-if="checkVisible('PROGRAMMATA', row.item, 'NO_ESEGUI_FORM')">
                                                        <b-button :id="'btneseguiform-' + row.index" v-b-tooltip.hover size="sm" variant="outline-danger no-text" title="Non Eseguita" @click="onClickNoEseguiAttivitaForm(row.item, row.index, $event.target)" class="mr-1 no-text">
                                                            <i class="far fa-times-circle"></i>
                                                        </b-button>
                                                    </template>
                                                    <b-button v-if="checkVisible('INFO', row.item)" v-b-tooltip.hover size="sm" variant="outline-primary no-text" title="Visualizza Attivita'" @click="onClickInfoAttivita(row.item, row.index, $event.target)" class="mr-1 no-text">
                                                        <b-icon icon="info"></b-icon>
                                                    </b-button>
                                                    <b-button v-if="checkVisible('INFO', row.item)" v-b-tooltip.hover size="sm" title="Allegati" variant="outline-success no-text" @click="onClickVisualizzaAllegati(row.item)">
                                                        <b-icon icon="file-earmark-plus"></b-icon>
                                                    </b-button>
                                                    <template v-if="checkVisible('INFO', row.item, 'PRINT')">
                                                        <!--        <print-component :documentRepository="true" :idRisorsa="row.item.id" :typeButton="'small'"> </print-component> -->
                                                        <!--  <print-component :data="row" :linkPrintData="linkPrintData(row.item)" typeButton="small"></print-component>-->
                                                        <!--    <b-button variant="outline-secondary no-text" v-if="row.item.statoFirma !== 'FIRMATA'">
                                                        <b-icon icon="pencil-square"></b-icon>
                                                    </b-button> -->
                                                        <!-- <b-button v-if="row.item.statoFirma === 'FIRMATA'" size="sm" variant="btn btn-purple waves-effect  waves-light width-sm no-text" style="margin-right: 3px" @click="onPrintPreview(row.item)">
                                                        <b-icon icon="printer"></b-icon>
                                                        <print-component v-if="btnPrintVisible && row.item.statoFirma !== 'FIRMATA'" :jsonData="printData" :linkPrintData="linkPrintData(row.item)" typeButton="small" :firmaGrafometrica="true" :nomeFile="nomeFile" :descrizione="descrizione" :tipoDocumento="tipoDocumento" :codiceApplicativo="codiceApplicativo"></print-component>
                                                    </b-button> -->
                                                    </template>
                                                </b-container>
                                            </template>
                                        </b-table>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </b-tab>
        </b-tabs>
        <b-modal ref="mdlListaAllegati" id="mdlListaAllegati" size="xl" style="height: 100%" no-close-on-backdrop no-close-on-esc hide-header-close>
            <allegato-model-component v-if="modalStep === 0" :idRisorsa="rigaSelezionata.idAttivita" @updateFiles="onUpdateFile()"></allegato-model-component>
            <paziente-allegati-edit-component v-if="modalStep === 1" :tipoRisorsa="'EVENTO'" :jsonData="data"></paziente-allegati-edit-component>
            <template #modal-footer>
                <b-button v-if="modalStep === 1" size="md" class="no-text" variant="outline-danger" @click="onClickUndo">Annulla</b-button>
                <b-button v-if="modalStep === 1" @click="onSalvaRichiesta" :disabled="modalStep !== 1" variant="outline-success">Salva</b-button>
                <b-button v-if="modalStep === 0" @click="onClickAddAllegati" variant="outline-success">Aggiungi</b-button>
                <b-button v-if="modalStep === 0" @click="onClickOk" variant="outline-primary">Chiudi</b-button>
            </template>
        </b-modal>
        <b-modal :title="dynamicJsonData.titolo" ref="mdlDynamicForm" size="lg" @shown="onShownDynamicForm" @ok="onOkDynamicForm" scrollable>
            <dynamic-form ref="cmpDynamicForm" :jsonData="dynamicJsonData" :isView="isDynamicFormView"></dynamic-form>
        </b-modal>
        <rsa-aree-pianificazione-edit-component ref="cmpRsaAreePianificazioneEditComponent" @afterSaveRequest="onAfterSaveRequestRsaAreePianificazioneComponent"></rsa-aree-pianificazione-edit-component>
        <rsa-aree-esegui-attivita-edit-component ref="cmpRsaAreeEseguiAttivitaEditComponent" @afterSaveRequest="onAfterSaveRequestRsaAreePianificazioneComponent" @closeModalAttivita="oncloseModalAttivitaEdit"></rsa-aree-esegui-attivita-edit-component>
        <rsa-aree-esegui-attivita-view-component ref="cmpRsaAreeEseguiAttivitaView" @afterCloseModal="onAfterCloseModalAttitvitaView"></rsa-aree-esegui-attivita-view-component>
        <modal-loading ref="cmpModalLoading"></modal-loading>
        <print-component v-show="false" ref="cmpPrint" :reportName="reportName" :printData="printData"></print-component>
        <modal-error ref="cmpModalError"></modal-error>
        <rsa-accesso-adi-modal-edit-component ref="cmpRsaAccessoAdiModalEdit" @afterSaveAccesso="onAfterSaveAccesso"></rsa-accesso-adi-modal-edit-component>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import RsaAreePianificazioneEditComponent from "./RsaAreePianificazioneEditComponent.vue";
import RsaAreeEseguiAttivitaEditComponent from "./RsaAreeEseguiAttivitaEditComponent.vue";
import RsaAreeEseguiAttivitaViewComponent from "./RsaAreeEseguiAttivitaViewComponent.vue";
import DynamicForm from "../../../utility/components/DynamicForm.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalLoading from "../../../../template/components/modal/components/ModalLoading.vue";
import PrintComponent from "../../../utility/components/PrintComponent.vue";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
import SaTabsScrollComponent from "../../../../template/components/utility/SaTabsScrollComponent.vue";
import RsaAccessoAdiModalEditComponent from "../../rsagestionepazientiadi/components/RsaAccessoAdiModalEditComponent.vue";
import NoDataComponent from "../../../../template/components/utility/NoDataComponent.vue";
import PazienteAllegatiEditComponent from "../../../paziente/allegati/components/PazienteAllegatiEditComponent.vue";
import AllegatoModelComponent from "../../../utility/components/AllegatoModelComponent.vue";
import toast from "../../../../template/layout/utility/sa-toast";

export default {
    mixins: [UtilityMixin],
    components: {
        PrintComponent,
        RsaAreePianificazioneEditComponent,
        DatePicker,
        RsaAreeEseguiAttivitaEditComponent,
        RsaAreeEseguiAttivitaViewComponent,
        DynamicForm,
        ModalLoading,
        ModalError,
        SaTabsScrollComponent,
        RsaAccessoAdiModalEditComponent,
        NoDataComponent,
        PazienteAllegatiEditComponent,
        AllegatoModelComponent,
    },
    created() {
        /* let me = this;me.loadAree(); */
    },
    mounted() {
        this.loadModalitaSomministrazione();
    },
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    computed: {
        listpianificazioni() {
            if (this.mostraTutte) {
                return this.pianificazioni.filter((e) => e.dettaglio != "ATTIVITA EXTRA");
            } else {
                return this.pianificazioni.filter((e) => {
                    const adesso = new Date().getTime();
                    return e.dettaglio !== "ATTIVITA EXTRA" && (e.dataFine === null || e.dataFine > adesso);
                });
            }
        },
        getAttivitaSomministrazioneFarmacologica() {
            const somministrazioneOrder = [...this.viaSomministrazioneOptions].sort((a, b) => {
                return (a.ordering || 0) - (b.ordering || 0);
            });
            const farmaciAlBisogno = [];
            const temp = {};
            this.attivitaSchedulate.forEach((farmaco) => {
                if (farmaco.rsaAttivitaPazienteBean?.tipoRiga == "ATTIVITA EXTRA") {
                    farmaciAlBisogno.push(farmaco);
                } else {
                    const via = farmaco.viaSomministrazione;
                    if (!temp[via]) {
                        temp[via] = [];
                    }
                    temp[via].push(farmaco);
                }
            });
            const returnValue = {};

            somministrazioneOrder.forEach((element) => {
                const via = element.nome;
                if (temp[via]) {
                    returnValue[via] = temp[via];
                }
            });
            if (farmaciAlBisogno.length > 0) {
                returnValue["alBisogno"] = farmaciAlBisogno;
            }

            return returnValue;
        },

        getFarmaciRaggruppati() {
            const somministrazioneOrder = [...this.viaSomministrazioneOptions].sort((a, b) => {
                return (a.ordering || 0) - (b.ordering || 0);
            });
            const temp = {};
            const farmaciAlBisogno = [];
            this.listpianificazioni.forEach((farmaco) => {
                if (farmaco.alBisogno) {
                    farmaciAlBisogno.push(farmaco);
                } else {
                    const via = farmaco.viaSomministrazione;
                    if (!temp[via]) {
                        temp[via] = [];
                    }
                    temp[via].push(farmaco);
                }
            });
            const returnValue = {};

            somministrazioneOrder.forEach((element) => {
                const via = element.nome;
                if (temp[via]) {
                    returnValue[via] = temp[via];
                }
            });
            if (farmaciAlBisogno.length > 0) {
                returnValue["alBisogno"] = farmaciAlBisogno;
            }

            return returnValue;
        },
        getEserciziRaggruppati() {
            const returnValue = {};

            if (this.listpianificazioni && this.listpianificazioni.length > 0) {
                returnValue["ESERCIZIO"] = this.listpianificazioni;
            }

            return returnValue;
        },
    },
    data() {
        return {
            viaSomministrazioneOptions: [],
            pathResourceAllegati: "/allegati",
            btnPermessiElimina: false,
            tblAttivitaSchedulateKey: 0,
            dynamicJsonData: { titolo: "Qui ci va il titolo", jsonForm: [] },
            idAccesso: null,
            activeTabIndex: 0,
            perPage: 100,
            raggruppa: true,
            raggruppaAttivita: true,
            mostraTutte: false,
            btnPrintVisible: true,
            pathResourcesAree: "/rsaaree",
            pathResourcesAttivita: "/rsaattivitapazienteschedulazioni",
            pathResourcesPrescrizioni: "/rsapazienteprescrizioni",
            pathResourceAllegato: "/",
            pathResourceAccessoAdi: "/rsaadiaccessi",
            areaSelezionata: "",
            modalStep: 0,
            data: { dataCaricamento: new Date().getTime(), idAnagrafica: null, idRisorsa: null },
            rigaSelezionata: {},
            jsonDataAccettazione: {},
            areeTabs: [],
            filtroScheduler: {
                dataDal: null,
                dataAl: null,
                idAccettazione: null,
                area: null,
            },
            pianificazioni: [],
            attivitaSchedulate: [],
            pathResourceDynamicForm: "/dynamicform",
            pathResourceDynamicFormData: null,
            isDynamicFormView: false,
            attivitaSelezionata: null,
            printData: {},
            jsonDataPrint: {},
            reportName: "",
            defaultValues: {},
            isSelectableTab: false,
            accessoAdi: {},
            statoAttivita: null,
            fields: [
                {
                    label: "Nome",
                    key: "nomeAttivita",
                    sortable: false,
                },
                {
                    label: "Programmazione",
                    key: "programmazione",
                    sortable: false,
                },
                // {
                // 	label: "Orari",
                // 	key: "orari",
                // 	sortable: true,
                // },
                {
                    label: "Indicazioni",
                    key: "indicazioni",
                    thStyle: "width: 20rem",
                    sortable: false,
                },
                {
                    label: "Inizio/Fine",
                    key: "inizioFine",
                    sortable: true,
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
            fieldsAttivitaSchedulate: [
                {
                    label: "Attività",
                    key: "nomeAttivita",
                    sortable: false,
                },
                {
                    label: "Data/ora Prevista",
                    key: "dataOraPrevista",
                    formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("DD/MM/YYYY HH:mm");
                        } else {
                            return "-----";
                        }
                    },
                    thStyle: "width: 10rem;",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
                {
                    label: "Data/Ora Esecuzione:",
                    key: "dataOraEffettuata",
                    formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("DD/MM/YYYY HH:mm");
                        } else {
                            return "-----";
                        }
                    },
                    thStyle: "width: 10rem",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    label: "Operatore",
                    key: "cognomeNomeOperatore",
                    thStyle: "width: 15rem",
                    sortable: true,
                },
                {
                    label: "Stato",
                    key: "stato",
                    thStyle: "width: 10rem",
                    sortable: false,
                },
                // {
                // 	label: "Firma",
                // 	key: "statoFirma",
                // },
                // {
                //     label: "Inizio/Fine",
                //     key: "inizioFine",
                //     sortable: true,
                // },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    methods: {
        init(jsonDataAccettazione, accessoAdi = null) {
            let me = this;
            me.jsonDataAccettazione = jsonDataAccettazione;
            if (accessoAdi) {
                me.accessoAdi = accessoAdi;
            }
            me.loadAree();
        },
        getBtnEseguiHidden(item) {
            //console.log(item.dataOraPrevista < new Date().getTime());
            return item.dataOraPrevista <= new Date().getTime();
        },

        getClass(sezione, valore) {
            switch (sezione) {
                case "stato":
                    if (valore == "IN CORSO") {
                        return "sa-ft-badge-blue";
                    } else if (valore == "PROGRAMMATA") {
                        return "sa-ft-badge-default";
                    } else if (valore == "ESEGUITA") {
                        return "sa-ft-badge-green";
                    } else {
                        return "sa-ft-badge-red";
                    }
                case "card":
                    if (valore == "IN CORSO") {
                        return "sa-ft-badge-blue";
                    } else if (valore == "PROGRAMMATA") {
                        return "sa-ft-badge-default";
                    } else if (valore == "ESEGUITA") {
                        return "sa-ft-badge-green";
                    } else {
                        return "sa-ft-badge-red";
                    }
                default:
                    break;
            }
        },
        getTestoHtmlNomeAttivita(prescrizione, sezione) {
            let returnValue = prescrizione.dettaglio;
            if (prescrizione.area != "SOMMINISTRAZIONE TERAPEUTICA" && prescrizione.area != "RIABILITAZIONE MOTORIA") {
                return;
            }
            switch (sezione) {
                case "ATTIVITA":
                    if (prescrizione.rsaAttivitaPazienteBean?.tipoRiga == "ATTIVITA EXTRA") {
                        let attivitaExtra = prescrizione.rsaAttivitaPazienteBean;
                        let returnValue = attivitaExtra.descrizioneAttivitaExtra;
                        if (prescrizione.paramsPrescrizione != "{}") {
                            let params = "{}";
                            try {
                                params = JSON.parse(prescrizione.paramsPrescrizione);
                                if (params.durata) {
                                    returnValue += `Durata: <b>${params.durata}</b>`;
                                }
                            } catch (error) {
                                error;
                            }
                        }
                        if (prescrizione.viaSomministrazione) {
                            returnValue += `Via Somministrazione: <b>${prescrizione.viaSomministrazione}</b>`;
                        }

                        return returnValue;
                    } else {
                        let returnValue = prescrizione.dettaglio;
                        if (prescrizione.paramsPrescrizione != "{}") {
                            let params = "{}";

                            try {
                                params = JSON.parse(prescrizione.paramsPrescrizione);
                                if (params.durata) {
                                    returnValue += `Durata: <b>${params.durata}</b>`;
                                }
                            } catch (error) {
                                error;
                            }
                        }
                        if (prescrizione.viaSomministrazione) {
                            returnValue += `<br/> Via Somministrazione: <b>${prescrizione.viaSomministrazione}</b>`;
                        }
                        return returnValue;
                    }
                case "PRESCRIZIONE":
                    if (prescrizione.paramsPrescrizione != "{}") {
                        let params = "";
                        try {
                            if (prescrizione.paramsPrescrizione != null) {
                                params = JSON.parse(prescrizione.paramsPrescrizione);

                                if (params.durata) {
                                    returnValue += `Durata: <b>${params.durata}</b>`;
                                }
                            }
                        } catch (error) {
                            error;
                        }
                    }
                    if (prescrizione.viaSomministrazione) {
                        returnValue += `<br/>Via Somministrazione: <b>${prescrizione.viaSomministrazione}</b>`;
                    }
                    return returnValue;
                default:
                    break;
            }
        },
        onScaricaCsv() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcesPrescrizioni + "/download/" + me.jsonDataAccettazione.id;
            axios({
                url: link, //your url
                method: "GET",
                responseType: "blob", // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                let nomeFile = "Terapie_" + me.formatDate(new Date().getTime());
                link.setAttribute("download", nomeFile + ".csv"); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        getAttivita(item) {
            let returnValue = item.nomeAttivita;
            if (!item.dettaglio.includes("ATTIVITA EXTRA")) {
                if (item.dettaglio) {
                    returnValue += " <b> " + item.dettaglio.trim() + "  </b>";
                }
                if (item.nomeAttivita == "SOMMINISTRAZIONE FARMACOLOGICA") {
                    returnValue += `<b class="text-primary">${item.viaSomministrazione}</b>`;
                }
            } else {
                if (item.nomeAttivita == "SOMMINISTRAZIONE FARMACOLOGICA") {
                    let attivitaExtra = item.rsaAttivitaPazienteBean;
                    if (attivitaExtra) {
                        returnValue += "<br>";
                        returnValue += attivitaExtra.descrizioneAttivitaExtra ? attivitaExtra.descrizioneAttivitaExtra : "";
                        returnValue += "<br>";
                        returnValue += `<b class="text-primary">${item.viaSomministrazione}</b>`;
                    }
                }
            }
            return returnValue;
        },

        getDose(item) {
            let response = "";
            if (item.params) {
                let params = {};
                try {
                    params = JSON.parse(item.params);
                    response += params.quantita + " " + params.unitaMisura;
                } catch (e) {
                    e;
                }
            }
            return response;
        },
        loadStampeReport() {
            let me = this;
            // me.printData = {};
            let id = this.$route.query.idAccettazione;
            me.loadDataResources("/rsaattivitapazienteschedulazioni/printdata/" + id, me.filtroScheduler, me.resultResponseStampa, me.resultErrorStampa);
        },
        onClickStampa() {
            let me = this;
            me.$refs.cmpPrint.onPrint();
        },
        resultResponseStampa(response) {
            let me = this;
            me.reportName = "RsaSomministrazioni";
            me.printData = response.data.data;
            me.printData.reportName = "RsaSomministrazioni";
            //me.$refs.cmpPrint.print(response.data.data);
        },
        resultErrorStampa(error) {
            let me = this;
            let messaggio = error.response.messaggio ? error.response.messaggio : "Stampa non disponibile";
            me.$refs.cmpModalError.show(messaggio + "#");
        },
        onHoverStatoFirma(item) {
            let firma = "";
            if (item.statoFirma == "FIRMATA") {
                firma = "SCHEDA FIRMATA";
            } else {
                firma = "SCHEDA NON FIRMATA";
            }
            return firma;
        },
        checkVisible(stato, item, operazione) {
            let returnValue = false;
            if (item.stato === stato) {
                if (item.idForm && operazione === "ESEGUI_FORM") {
                    returnValue = true;
                } else if (item.idForm && operazione === "NO_ESEGUI_FORM") {
                    returnValue = true;
                } else if (!item.idForm && operazione === "ESEGUI") {
                    returnValue = true;
                }
            } else if (stato === "INFO" && item.stato !== "PROGRAMMATA") {
                returnValue = true;
            } else if (stato === "INFO" && (item.stato == "EROGATA" || item.stato == "NON EROGATA")) {
                returnValue = true;
            }

            return returnValue;
        },

        getRowClass(item, type) {
            let dataOraAttuale = moment(new Date());
            let dataOraPrevista = moment(new Date(item.dataOraPrevista));
            let minuti = dataOraAttuale.diff(dataOraPrevista, "minute");
            if (item.stato === "NON ESEGUITA") {
                return "sa-table-row-danger";
            } else if (minuti > 15 && type === "row") {
                return "sa-table-row-warning";
            } else {
                return null;
            }
        },
        loadAree() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcesAree;
            axios
                .get(link)
                .then((response) => {
                    me.areeTabs = response.data.data.list;
                    me.areaSelezionata = me.areeTabs[0].nome;
                    me.filtroScheduler.dataDal = new Date().getTime();
                    me.loadAttivita();
                })
                .catch(() => {});
        },
        loadModalitaSomministrazione() {
            let link = process.env.VUE_APP_PATH_API + "/rsapazienteprescrizionimodalitasomministrazione";
            axios
                .get(link)
                .then((response) => {
                    this.viaSomministrazioneOptions = response.data.data.list;
                })
                .catch(() => {});
        },
        loadAttivita() {
            let me = this;
            me.$refs.cmpModalLoading.show();
            me.pianificazioni = [];
            let link = process.env.VUE_APP_PATH_API + me.pathResourcesAttivita;
            let filtro = {
                idAccettazione: me.jsonDataAccettazione.id,
                area: me.areaSelezionata,
            };
            if (me.areaSelezionata === "SOMMINISTRAZIONE TERAPEUTICA") {
                this.loadStampeReport();
            }

            axios
                .get(link, { params: filtro })
                .then((response) => {
                    me.loadDataScheduler();
                    me.pianificazioni = response.data.data.list;
                    me.$refs.cmpModalLoading.close();
                })
                .catch(() => {
                    me.$refs.cmpModalLoading.close();
                });
        },
        onInputTabs(e) {
            let me = this;
            // let area = this.areeTabs[e];
            me.areaSelezionata = this.areeTabs[e].nome;
            me.loadAttivita();
            me.filtroScheduler.dataDal = new Date().getTime();
            // me.loadDataScheduler();
            me.tblAttivitaSchedulateKey++;
        },
        onClickNuovaPianificazione() {
            let me = this;
            // let area = me.areeTabs.reduce((acc, currentValue) => rec.nome === me.areaSelezionata);
            let area = me.areeTabs.reduce((row, currentRow) => (row.nome === me.areaSelezionata ? row : currentRow));

            if (this.jsonDataAccettazione.statoAttuale === "DIMESSO" || this.jsonDataAccettazione.statoAttuale === "TRASFERITO" || this.jsonDataAccettazione.statoAttuale === "ASSENTE" || this.jsonDataAccettazione.statoAttuale === "SOSPESO_ADI") {
                let messaggio = me.jsonDataAccettazione.statoAttuale === "SOSPESO_ADI" ? "Non è possibile questa operazione su un paziente con percorso ADI sospeso" : me.jsonDataAccettazione.statoAttuale === "DIMESSO" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
                toast.error(messaggio);
                return;
            }
            me.$refs.cmpRsaAreePianificazioneEditComponent.edit(
                {
                    id: null,
                    nomeAttivita: null,
                    dataInizio: new Date().getTime(),
                    dataFine: null,
                    listaOrari: [{ dataInizio: new Date().getTime(), giorni: null, orari: null }],
                    idAccettazione: me.jsonDataAccettazione.id,
                    idPaziente: me.jsonDataAccettazione.accettazioneAnagrafica.id,
                    area: me.areaSelezionata,
                    dettaglio: "",
                },
                area,
                me.jsonDataAccettazione,
            );
        },
        onClickAttivitaExtra() {
            let me = this;
            // let area = me.areeTabs.reduce((acc, currentValue) => rec.nome === me.areaSelezionata);
            let area = me.areeTabs.reduce((row, currentRow) => (row.nome === me.areaSelezionata ? row : currentRow));

            if (this.jsonDataAccettazione.statoAttuale === "DIMESSO" || this.jsonDataAccettazione.statoAttuale === "TRASFERITO" || this.jsonDataAccettazione.statoAttuale === "ASSENTE" || this.jsonDataAccettazione.statoAttuale === "SOSPESO_ADI") {
                let messaggio = me.jsonDataAccettazione.statoAttuale === "SOSPESO_ADI" ? "Non è possibile questa operazione su un paziente con percorso ADI sospeso" : me.jsonDataAccettazione.statoAttuale === "DIMESSO" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
                toast.error(messaggio);
                return;
            }
            let item = {
                rsaAttivitaPazienteBean: null,
                area: area,
                idAccettazione: me.jsonDataAccettazione.id,
                indicazioni: null,
                note: null,
            };
            if (item.rsaAttivitaPazienteBean === null) {
                item.dataOraEffettuata = new Date().getTime();
            }
            me.$refs.cmpRsaAreeEseguiAttivitaEditComponent.add(item, "ESEGUITA");
        },
        onAfterSaveRequestRsaAreePianificazioneComponent() {
            let me = this;
            me.loadDataScheduler();
            me.loadAttivita();
        },
        onAfterCloseModalAttitvitaView() {
            let me = this;
            me.loadDataScheduler();
            me.loadAttivita();
        },
        onClickEdit(item) {
            let me = this;
            let area = me.areeTabs.reduce((row, currentRow) => (row.nome === me.areaSelezionata ? row : currentRow));
            me.$refs.cmpRsaAreePianificazioneEditComponent.edit(item, area, me.jsonDataAccettazione);
        },
        onClickDelete(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione ?", {
                    title: "Titolo",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        let link = process.env.VUE_APP_PATH_API + me.pathResourcesAttivita + "/" + item.id;
                        UtilityMixin.methods.restCallDelete(link, me.deleteSuccess, me.deleteError);
                    }
                })
                .catch((err) => {
                    err;
                });
        },
        deleteSuccess(response) {
            let me = this;
            me.$bvToast.toast(response.data.messaggio, {
                title: "",
                variant: "success",
                solid: true,
            });
            me.loadAttivita();
        },
        deleteError(error) {
            let me = this;
            me.$emit("afterLoadData");
            me.$refs.cmpModalError.show(error.response.data.messaggio + "#");
        },
        onSubmit() {
            let me = this;
            me.loadDataScheduler();
        },
        onReset() {
            let me = this;
            me.attivitaSchedulate = [];
            me.filtroScheduler = {
                dataDal: new Date().getTime(),
                dataAl: null,
                idAccettazione: me.jsonDataAccettazione.id,
                area: me.jsonDataAccettazione.areaSelezionata,
            };
            me.loadDataScheduler();
        },
        loadDataScheduler() {
            let me = this;
            me.attivitaSchedulate = [];
            let link = process.env.VUE_APP_PATH_API + me.pathResourcesAttivita + "/scheduler";
            me.filtroScheduler.idAccettazione = me.jsonDataAccettazione.id;
            me.filtroScheduler.area = me.areaSelezionata;
            axios
                .get(link, { params: me.filtroScheduler })
                .then((response) => {
                    me.attivitaSchedulate = response.data.data;
                })
                .catch((error) => {
                    // me.$emit("afterSaveRequest");
                    let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
                    toast.error(messaggio);
                });
        },
        onClickEseguiAttivita(item) {
            let me = this;
            me.statoAttivita = "ESEGUITA";
            if (this.jsonDataAccettazione.statoAttuale === "DIMESSO" || this.jsonDataAccettazione.statoAttuale === "TRASFERITO" || this.jsonDataAccettazione.statoAttuale === "ASSENTE" || this.jsonDataAccettazione.statoAttuale === "SOSPESO_ADI") {
                let messaggio = me.jsonDataAccettazione.statoAttuale === "SOSPESO_ADI" ? "Non è possibile questa operazione su un paziente con percorso ADI sospeso" : me.jsonDataAccettazione.statoAttuale === "DIMESSO" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
                toast.error(messaggio);
                return;
            }
            me.attivitaSelezionata = item;
            if (me.jsonDataAccettazione.statoAttuale === "ACCETTATO_ADI" || me.jsonDataAccettazione.statoAttuale === "ACCETTATO_HOSPICE") {
                me.verificaAccessoAdi();
            } else {
                if (item.rsaAttivitaPazienteBean === null) {
                    item.dataOraEffettuata = new Date().getTime();
                }
                me.$refs.cmpRsaAreeEseguiAttivitaEditComponent.add(item);
            }
        },
        onClickNoEseguiAttivitaForm(item) {
            let me = this;
            me.statoAttivita = "NON ESEGUITA";
            if (this.jsonDataAccettazione.statoAttuale === "DIMESSO" || this.jsonDataAccettazione.statoAttuale === "TRASFERITO" || this.jsonDataAccettazione.statoAttuale === "ASSENTE" || this.jsonDataAccettazione.statoAttuale === "SOSPESO_ADI") {
                let messaggio = me.jsonDataAccettazione.statoAttuale === "SOSPESO_ADI" ? "Non è possibile questa operazione su un paziente con percorso ADI sospeso" : me.jsonDataAccettazione.statoAttuale === "DIMESSO" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
                toast.error(messaggio);
                return;
            }
            me.attivitaSelezionata = item;
            if (me.jsonDataAccettazione.statoAttuale === "ACCETTATO_ADI" || me.jsonDataAccettazione.statoAttuale === "ACCETTATO_HOSPICE") {
                me.verificaAccessoAdi();
            } else {
                if (item.rsaAttivitaPazienteBean === null) {
                    item.dataOraEffettuata = new Date().getTime();
                }
                me.$refs.cmpRsaAreeEseguiAttivitaEditComponent.add(item, "NON ESEGUITA");
            }
        },
        onClickEseguiAttivitaForm(item) {
            let me = this;
            me.statoAttivita = "ESEGUITA";
            if (this.jsonDataAccettazione.statoAttuale === "DIMESSO" || this.jsonDataAccettazione.statoAttuale === "TRASFERITO" || this.jsonDataAccettazione.statoAttuale === "ASSENTE" || this.jsonDataAccettazione.statoAttuale === "SOSPESO_ADI") {
                let messaggio = me.jsonDataAccettazione.statoAttuale === "SOSPESO_ADI" ? "Non è possibile questa operazione su un paziente con percorso ADI sospeso" : me.jsonDataAccettazione.statoAttuale === "DIMESSO" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
                toast.error(messaggio);
                return;
            }
            me.attivitaSelezionata = item;
            if (me.jsonDataAccettazione.statoAttuale === "ACCETTATO_ADI" || me.jsonDataAccettazione.statoAttuale === "ACCETTATO_HOSPICE") {
                me.verificaAccessoAdi();
            } else {
                me.$refs.cmpModalLoading.show();
                me.isDynamicFormView = false;
                UtilityMixin.methods.loadDataResources(me.pathResourceDynamicForm + "/" + item.idForm, {}, me.loadDynamicFormSuccess, me.loadDynamicFormError);
            }
        },
        loadDynamicFormSuccess(response) {
            let me = this;
            let dynamicJsonData = response.data.data;
            dynamicJsonData.jsonForm = JSON.parse(response.data.data.jsonForm);
            me.dynamicJsonData = dynamicJsonData;
            me.pathResourceDynamicFormData = dynamicJsonData.pathModule;
            me.getJsonForm(me.dynamicJsonData.jsonForm);
            me.$refs.cmpModalLoading.close();
            me.$refs.mdlDynamicForm.show();
        },
        loadDynamicFormError(error) {
            error;
        },
        onClickInfoAttivita(item) {
            let me = this;
            if (item.idForm && item.stato === "ESEGUITA") {
                me.attivitaSelezionata = item;
                me.loadDinamicFormView(item.idForm);
            } else {
                me.$refs.cmpRsaAreeEseguiAttivitaView.add(item);
            }
        },
        loadDinamicFormView(idForm) {
            let me = this;
            me.$refs.cmpModalLoading.show();
            UtilityMixin.methods.loadDataResources(me.pathResourceDynamicForm + "/" + idForm, {}, me.loadDinamicFormViewSuccess, me.loadDinamicFormViewError);
        },
        loadDinamicFormViewSuccess(response) {
            let me = this;
            if (response.data.data.pathModule) {
                me.$refs.cmpModalLoading.close();
                let dynamicJsonData = response.data.data;
                dynamicJsonData.jsonForm = JSON.parse(response.data.data.jsonForm);
                me.dynamicJsonData = dynamicJsonData;
                let link = process.env.VUE_APP_PATH_API + response.data.data.pathModule + "/attivita/" + me.attivitaSelezionata.rsaAttivitaPazienteBean.id;
                axios
                    .get(link)
                    .then((response) => {
                        me.defaultValues = response.data.data;
                        me.defaultValues.ospite = me.jsonDataAccettazione.accettazioneAnagrafica.nome + " " + me.jsonDataAccettazione.accettazioneAnagrafica.cognome;
                        me.defaultValues.educatore = me.utente.firstname + " " + me.utente.lastname;
                        me.defaultValues.numero = me.jsonDataAccettazione.numero;
                        me.defaultValues.dataNascita = me.formatDate(me.jsonDataAccettazione.accettazioneAnagrafica.dataNascita);
                        me.isDynamicFormView = true;
                        me.$refs.mdlDynamicForm.show();
                    })
                    .catch((error) => {
                        me.$emit("afterSaveRequest");
                        let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
                        if (!messaggio) {
                            messaggio = error.message;
                        }
                        toast.error(messaggio);
                    });
            } else {
                toast.error("Path del modulo non configurato");
            }
        },
        loadDinamicFormViewError(error) {
            error;
        },

        onShownDynamicForm() {
            let me = this;
            me.$refs.cmpDynamicForm.setForm(me.defaultValues);
        },
        onOkDynamicForm(bvModalEvent) {
            let me = this;
            if (me.isDynamicFormView) {
                me.$refs.mdlDynamicForm.hide();
            } else {
                let responseJsonData = this.$refs.cmpDynamicForm.getJsonData();
                responseJsonData.idAccettazione = me.attivitaSelezionata.idAccettazione;
                responseJsonData.idPaziente = me.attivitaSelezionata.idPaziente;
                responseJsonData.dataOraPrevista = me.attivitaSelezionata.dataOraPrevista;
                responseJsonData.dataOraEffettuata = me.attivitaSelezionata.dataOra;
                responseJsonData.dataOra = me.attivitaSelezionata.dataOra;
                responseJsonData.idRsaAttivitaPazienteSchedulazione = me.attivitaSelezionata.idRsaAttivitaPazienteSchedulazione;
                responseJsonData.nomeAttivita = me.attivitaSelezionata.nomeAttivita;
                responseJsonData.dettaglio = me.attivitaSelezionata.dettaglio;
                responseJsonData.indicazioni = me.attivitaSelezionata.indicazioni;
                responseJsonData.idAttivita = me.attivitaSelezionata.idAttivita;
                responseJsonData.idForm = me.dynamicJsonData.id;
                responseJsonData.dataOra = new Date().getTime();
                me.dynamicJsonData.note = me.dynamicJsonData.note ? me.dynamicJsonData.note : " ";
                responseJsonData.note = responseJsonData.note ? responseJsonData.note : me.dynamicJsonData.note;
                delete responseJsonData.ospite;
                delete responseJsonData.dataNascita;
                delete responseJsonData.educatore;
                delete responseJsonData.numero;

                //delete responseJsonData.dataOra;
                responseJsonData.tipoRiga = "ORDINARIA";
                bvModalEvent.preventDefault();

                me.creaAttivita(responseJsonData);
            }
        },
        creaAttivita(responseJsonData) {
            let me = this;
            me.$refs.cmpModalLoading.show();
            let link = process.env.VUE_APP_PATH_API + me.pathResourceDynamicFormData;

            axios
                .post(link, responseJsonData)
                .then(() => {
                    me.$emit("afterSaveRequest");
                    me.loadDataScheduler();
                    me.loadAttivita();
                    me.attivitaSelezionata = null;
                    me.$refs.mdlDynamicForm.hide();
                    me.$refs.cmpModalLoading.close();
                })
                .catch((error) => {
                    me.attivitaSelezionata = null;
                    me.$refs.cmpModalLoading.close();
                    me.$emit("afterSaveRequest");
                    let messaggio = "Errore non gestito";
                    if (error.response) {
                        if (error.response.data.messaggio) {
                            messaggio = error.response.data.messaggio;
                        } else {
                            messaggio = error.response.data;
                        }
                    }
                    toast.error(messaggio);
                });
        },
        getJsonForm(jsonForm) {
            let me = this;
            me.defaultValues = {};
            jsonForm.forEach((element) => {
                switch (element.type) {
                    case "select":
                        me.defaultValues[element.modelName] = null;
                        break;
                    case "datepicker":
                        me.defaultValues[element.modelName] = new Date().getTime();
                        break;
                }
            });
            me.defaultValues.ospite = me.jsonDataAccettazione.accettazioneAnagrafica.nome + " " + me.jsonDataAccettazione.accettazioneAnagrafica.cognome;
            // me.defaultValues.educatore = me.utente.firstname + " " + me.utente.lastname;
            me.defaultValues.operatore = me.utente.firstname + " " + me.utente.lastname;
            me.defaultValues.numero = me.jsonDataAccettazione.numero;
            me.defaultValues.dataNascita = this.formatDate(me.jsonDataAccettazione.accettazioneAnagrafica.dataNascita);
        },
        oncloseModalAttivitaEdit() {
            let me = this;
            me.attivitaSelezionata = null;
            me.loadDataScheduler();
        },
        isSelectable() {
            let me = this;
            return me.areaSelezionata === "SOMMINISTRAZIONE TERAPEUTICA";
        },
        onRowSelectedAttivita(items) {
            let me = this;
            if (items.length > 0) {
                me.isButtonMultiAttivita = true;
            }
        },
        verificaAccessoAdi() {
            let me = this;
            me.loadDataResources(me.pathResourceAccessoAdi + "/aperto/" + me.jsonDataAccettazione.id, {}, me.resultResponseVerificaAccesso, me.resultErrorVerificaAccesso);
        },
        resultResponseVerificaAccesso(response) {
            let me = this;
            me.accessoAdi = response.data.data;
            me.eseguiAttivitaAccesso();
        },
        resultErrorVerificaAccesso(error) {
            let me = this;
            if (error.response.status === 404) {
                me.$bvModal
                    .msgBoxOk("Accesso non aperto", {
                        title: "ATTENZIONE",
                        size: "sm",
                        okVariant: "outline-danger",
                        headerClass: "sa-msg-header-danger",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                    })
                    .then(() => {
                        me.$refs.cmpRsaAccessoAdiModalEdit.show(me.jsonDataAccettazione.id, "APERTO");
                    })
                    .catch((err) => {
                        err;
                    });
            } else {
                let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "";
                toast.error("Errore nel Servizio Accesso ADI" + messaggio);
                me.attivitaSelezionata = {};
            }
        },
        onAfterSaveAccesso(accessoAdi) {
            let me = this;
            me.accessoAdi = accessoAdi;
            me.$emit("afterSaveAccessoAdi");
            if (me.attivitaSelezionata) {
                me.eseguiAttivitaAccesso();
            }
        },
        eseguiAttivitaAccesso() {
            let me = this;
            if (me.attivitaSelezionata) {
                me.attivitaSelezionata.idAccesso = me.accessoAdi.id;
                if (me.attivitaSelezionata.idForm && me.statoAttivita !== "NON ESEGUITA") {
                    me.isDynamicFormView = false;
                    me.loadDataResources(me.pathResourceDynamicForm + "/" + me.attivitaSelezionata.idForm, {}, me.loadDynamicFormSuccess, me.loadDynamicFormError);
                } else {
                    if (me.attivitaSelezionata.rsaAttivitaPazienteBean === null) {
                        me.attivitaSelezionata.dataOraEffettuata = new Date().getTime();
                    }
                    me.$refs.cmpRsaAreeEseguiAttivitaEditComponent.add(me.attivitaSelezionata, me.statoAttivita);
                }
            }
        },
        salvaAccessoAdi(stato) {
            let me = this;
            me.$refs.cmpRsaAccessoAdiModalEdit.show(me.jsonDataAccettazione.id, stato);
        },
        onClickVisualizzaAllegati(item) {
            let me = this;
            console.log(item);

            me.rigaSelezionata = item;
            me.data.idRisorsa = item.idAttivita;
            me.data.idAnagrafica = item.idAccettazione;
            me.$refs.mdlListaAllegati.show();
            // me.$refs.mdlAllegatiList.loadData();
        },
        getDataPdf(obj) {
            // let me = this;
            let objPdf = {};
            objPdf.idRisorsa = obj.idRisorsa;
            objPdf.idAnagrafica = obj.idAnagrafica;
            objPdf.nomeFile = obj.nomeFile;
            objPdf.size = obj.size;
            objPdf.file = obj.file;
            objPdf.tipo = obj.tipo;
            objPdf.dataCaricamento = obj.dataCaricamento;
            objPdf.descrizione = obj.descrizione;
            objPdf.tipoDocumento = obj.tipoDocumento;
            return objPdf;
        },
        onClickAddAllegati() {
            let me = this;
            me.modalStep = 1;
        },
        onClickOk() {
            let me = this;
            me.modalStep = 0;
            me.$refs.mdlListaAllegati.hide();
        },
        onClickUndo() {
            let me = this;
            // me.$refs.mdlAllegatiList.loadData();
            me.modalStep = 0;
        },
        onSalvaRichiesta() {
            let me = this;
            let obj = me.getDataPdf(me.data);
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAllegati;
            me.showModalLoading = true;
            axios
                .post(link, obj)
                .then(() => {
                    me.modalStep = 0;
                    me.showModalLoading = false;
                    // me.$refs.mdlAllegatiList.loadData();
                    me.$emit("updateFiles");
                    this.$bvToast.toast(`${this.getLabelTraduora("patient.afa.lblToastSuccessUpload")} - ${this.data.nomeFile}`, {
                        title: "File Upload",
                        autoHideDelay: 2000,
                        variant: "success",
                    });
                })
                .catch((error) => {
                    let message = "";
                    error.response ? error.response.data.messaggio : "Errore non gestito";
                    if (error.response) {
                        message = error.response.data.messaggio ? error.response.data.messaggio : "Codice Errore: " + error.response.status + ", non gestito";
                    }
                    if (error.response) {
                        this.$bvModal
                            .msgBoxOk(message, {
                                title: "ATTENZIONE",
                                size: "sm",
                                okVariant: "outline-danger",
                                headerClass: "sa-msg-header-danger",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                            })
                            .then(() => {})
                            .catch((err) => {
                                console.log(err);
                            });
                    }
                });
        },
        onUpdateFile() {
            let me = this;
            me.childKey++;
        },
    },
};
</script>
<style scoped>
.sa-card-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 8px;
}

/* La Card Moderna */
.sa-ft-modern-card {
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    position: relative;
    transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1), border-color 0.3s ease;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
    z-index: 1;
}

.sa-ft-modern-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 20px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06);
    z-index: 10;
}

.sa-ft-modern-card:hover {
    transform: translateY(-5px);
    border-color: var(--hover-color);
    box-shadow: 0 12px 20px rgba(0, 0, 0, 0.1), 0 4px 8px var(--hover-color);
    z-index: 10;
}

.sa-ft-modern-card.status-programmata::before {
    background-color: #28a745;
    /* Verde */
}

.sa-ft-modern-card.status-in-corso::before {
    background-color: #007bff;
    /* Blu */
}

.sa-ft-icona-collapse {
    transition: transform 0.5s ease-in-out;
    color: #6c757d;
    font-size: 14px;
}

/* Quando BootstrapVue chiude il pannello, aggiunge la classe .collapsed al toggle */
.sa-utility-section.collapsed .sa-ft-icona-collapse {
    transform: rotate(180deg);
}

/* Effetto hover */
.sa-utility-section:hover .sa-ft-icona-collapse {
    color: var(--bg-sidebar);
}

/* Tipografia */
.sa-ft-label-pai {
    font-size: 0.65rem;
    font-weight: 700;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 2px;
}

.sa-ft-valore-pai {
    font-size: 0.9rem;
    color: #333;
}

.sa-ft-valore-pai.primary-text {
    color: #0056b3;
    font-weight: 600;
}

/* Badge Arrotondati */
.sa-ft-badge {
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 700;
    display: inline-block;
    border: 1px solid #dee2e6;
    max-width: fit-content;
}

.sa-ft-badge-blue {
    background-color: #e8f0fe;
    color: #1a73e8;
    border-left: 3px solid #1a73e8 !important;
    border: 1px solid #1a73e8;
}

.sa-ft-badge-default {
    background-color: #f8f9fa;
    color: #666;
    border-left: 3px solid #666 !important;
    border: 1px solid #666;
}

.sa-ft-badge-red {
    background-color: #f8f9fa;
    color: #b42e2ec7;
    border-left: 3px solid #b42e2ec7 !important;
    border: 1px solid #b42e2ec7;
}

.sa-ft-badge-green {
    background-color: #f8f9fa;
    color: #28a745;
    border-left: 3px solid #28a745 !important;
    border: 1px solid #28a745;
}

.ft-gap-8-px {
    gap: 8px;
}
</style>
